import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <Link to="/" className="header-logo">
          <div className="logo-wrapper">
            <div className="logo-orange-bar"></div>
            <div className="logo-blue-shape">
              <div className="logo-blue-vertical"></div>
              <div className="logo-blue-horizontal"></div>
            </div>
            <div className="logo-m">M</div>
          </div>
          <div className="logo-text">
            <span className="logo-text-main">CM GROUPS</span>
            <span className="logo-text-tagline">Engineering Your Dreams</span>
          </div>
        </Link>

        {/* Desktop Navigation */}
        <nav className="header-nav">
          <ul className="nav-links">
            <li><Link to="/" className="nav-link">Home</Link></li>
            <li><a href="#services" className="nav-link">Services</a></li>
            <li><a href="#projects" className="nav-link">Projects</a></li>
            <li><a href="#contact" className="nav-link">Contact</a></li>
          </ul>
          <button 
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="header-cta"
          >
            Get Quote
          </button>
        </nav>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="mobile-menu-btn"
          aria-label="Toggle menu"
        >
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {isMobileMenuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        <ul className="mobile-nav-links">
          <li><Link to="/" className="mobile-nav-link" onClick={() => setIsMobileMenuOpen(false)}>Home</Link></li>
          <li><a href="#services" className="mobile-nav-link" onClick={() => setIsMobileMenuOpen(false)}>Services</a></li>
          <li><a href="#projects" className="mobile-nav-link" onClick={() => setIsMobileMenuOpen(false)}>Projects</a></li>
          <li><a href="#contact" className="mobile-nav-link" onClick={() => setIsMobileMenuOpen(false)}>Contact</a></li>
          <li>
            <button 
              onClick={() => {
                setIsMobileMenuOpen(false);
                document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="header-cta"
              style={{ width: '100%', marginTop: '16px' }}
            >
              Get Quote
            </button>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Header;
